import { AppEnvironment } from '../enums/appEnvironment.enum'

import { getAppEnvironment } from './environment'

/** Artifact feeds UI is limited to local and dev until PRD/TST backends are ready. */
export function isArtifactFeedsSettingsEnabled(): boolean {
  const env = getAppEnvironment()

  return env === AppEnvironment.LOCALHOST || env === AppEnvironment.DEV
}
